import { Component, Input, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EmptyStateComponent } from '@tecalisdev/infinity';
import { DetailResultTileComponent } from '../../../../processes/components/detail-result-tile/detail-result-tile.component';
import { PROCESS_STATUS } from '../../../../processes/models/processes.models';
import { ProcessHelperService } from '../../../../processes/services/process-helper.service';
import { IOperationDetailResponse, OPERATION_TYPE } from '../../../models/operations.models';
import { resolveOperationDetailEffectiveState } from '../../../utils/form-operation-match-data.util';
import { OperationDetailTabsDetailsOcrComponent } from './operation-detail-tabs-details-ocr/operation-detail-tabs-details-ocr.component';
import { OperationDetailTabsDetailsPolComponent } from './operation-detail-tabs-details-pol/operation-detail-tabs-details-pol.component';
import { OperationDetailTabsDetailsDocumentsComponent } from './operation-detail-tabs-details-documents/operation-detail-tabs-details-documents.component';
import { OperationDetailTabsDetailsFinancialEvaluationComponent } from './operation-detail-tabs-details-financial-evaluation/operation-detail-tabs-details-financial-evaluation.component';
import { OperationDetailTabsDetailsBormeComponent } from './operation-detail-tabs-details-borme/operation-detail-tabs-details-borme.component';
import { OperationDetailTabsDetailsFormComponent } from './operation-detail-tabs-details-form/operation-detail-tabs-details-form.component';
import { OperationDetailTabsDetailsMessagingComponent } from './operation-detail-tabs-details-messaging/operation-detail-tabs-details-messaging.component';

@Component({
	selector: 'app-operation-detail-tabs-details',
	imports: [
		TranslatePipe,
		EmptyStateComponent,
		DetailResultTileComponent,
		OperationDetailTabsDetailsPolComponent,
		OperationDetailTabsDetailsOcrComponent,
		OperationDetailTabsDetailsDocumentsComponent,
		OperationDetailTabsDetailsFinancialEvaluationComponent,
		OperationDetailTabsDetailsBormeComponent,
		OperationDetailTabsDetailsFormComponent,
		OperationDetailTabsDetailsMessagingComponent,
	],
	templateUrl: './operation-detail-tabs-details.component.html',
	styleUrl: './operation-detail-tabs-details.component.scss',
})
export class OperationDetailTabsDetailsComponent {
	@Input() detail: IOperationDetailResponse;

	public OPERATION_TYPE = OPERATION_TYPE;
	public PROCESS_STATUS = PROCESS_STATUS;

	private readonly processHelper = inject(ProcessHelperService);

	public get effectiveState(): string | undefined {
		return resolveOperationDetailEffectiveState(this.detail);
	}

	public get showResultTile(): boolean {
		const state = this.effectiveState;
		const opData = this.detail?.data as { actions?: { KO?: unknown }; state?: string } | undefined;
		return (
			state === PROCESS_STATUS.KO ||
			state === PROCESS_STATUS.PENDING ||
			Boolean(this.detail?.status_reasons) ||
			this.processHelper.shouldShowOperationKoReason(opData)
		);
	}
}
